module.exports = __webpack_public_path__ + "static/media/THE_BOOK_CLUB_Makassar.ef1cc130.png";